"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumProtocolException = exports.NumProtocolErrorCode = exports.NumLookupBadDoHResponse = exports.NumLookupEmptyResult = exports.NumLookupRedirect = exports.RelativePathException = exports.NumMaximumRedirectsExceededException = exports.RrSetIncompleteException = exports.RrSetHeaderFormatException = exports.InvalidDnsResponseException = exports.BadDnsStatusException = exports.NumInvalidRedirectException = exports.NumNotImplementedException = exports.NumInvalidDnsQueryException = exports.NumBadUrlException = exports.NumInvalidParameterException = exports.NumException = void 0;
var NumException = (function (_super) {
    __extends(NumException, _super);
    function NumException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumException.prototype);
        return _this;
    }
    return NumException;
}(Error));
exports.NumException = NumException;
var NumInvalidParameterException = (function (_super) {
    __extends(NumInvalidParameterException, _super);
    function NumInvalidParameterException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumInvalidParameterException.prototype);
        return _this;
    }
    return NumInvalidParameterException;
}(NumException));
exports.NumInvalidParameterException = NumInvalidParameterException;
var NumBadUrlException = (function (_super) {
    __extends(NumBadUrlException, _super);
    function NumBadUrlException(msg, cause) {
        var _this = _super.call(this, msg) || this;
        _this.cause = cause;
        Object.setPrototypeOf(_this, NumBadUrlException.prototype);
        return _this;
    }
    return NumBadUrlException;
}(NumException));
exports.NumBadUrlException = NumBadUrlException;
var NumInvalidDnsQueryException = (function (_super) {
    __extends(NumInvalidDnsQueryException, _super);
    function NumInvalidDnsQueryException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumInvalidDnsQueryException.prototype);
        return _this;
    }
    return NumInvalidDnsQueryException;
}(NumException));
exports.NumInvalidDnsQueryException = NumInvalidDnsQueryException;
var NumNotImplementedException = (function (_super) {
    __extends(NumNotImplementedException, _super);
    function NumNotImplementedException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumNotImplementedException.prototype);
        return _this;
    }
    return NumNotImplementedException;
}(NumException));
exports.NumNotImplementedException = NumNotImplementedException;
var NumInvalidRedirectException = (function (_super) {
    __extends(NumInvalidRedirectException, _super);
    function NumInvalidRedirectException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumInvalidRedirectException.prototype);
        return _this;
    }
    return NumInvalidRedirectException;
}(NumException));
exports.NumInvalidRedirectException = NumInvalidRedirectException;
var BadDnsStatusException = (function (_super) {
    __extends(BadDnsStatusException, _super);
    function BadDnsStatusException(status, msg) {
        var _this = _super.call(this, msg) || this;
        _this.status = status;
        Object.setPrototypeOf(_this, BadDnsStatusException.prototype);
        return _this;
    }
    return BadDnsStatusException;
}(NumException));
exports.BadDnsStatusException = BadDnsStatusException;
var InvalidDnsResponseException = (function (_super) {
    __extends(InvalidDnsResponseException, _super);
    function InvalidDnsResponseException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, InvalidDnsResponseException.prototype);
        return _this;
    }
    return InvalidDnsResponseException;
}(NumException));
exports.InvalidDnsResponseException = InvalidDnsResponseException;
var RrSetHeaderFormatException = (function (_super) {
    __extends(RrSetHeaderFormatException, _super);
    function RrSetHeaderFormatException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, RrSetHeaderFormatException.prototype);
        return _this;
    }
    return RrSetHeaderFormatException;
}(NumException));
exports.RrSetHeaderFormatException = RrSetHeaderFormatException;
var RrSetIncompleteException = (function (_super) {
    __extends(RrSetIncompleteException, _super);
    function RrSetIncompleteException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, RrSetIncompleteException.prototype);
        return _this;
    }
    return RrSetIncompleteException;
}(NumException));
exports.RrSetIncompleteException = RrSetIncompleteException;
var NumMaximumRedirectsExceededException = (function (_super) {
    __extends(NumMaximumRedirectsExceededException, _super);
    function NumMaximumRedirectsExceededException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumMaximumRedirectsExceededException.prototype);
        return _this;
    }
    return NumMaximumRedirectsExceededException;
}(NumException));
exports.NumMaximumRedirectsExceededException = NumMaximumRedirectsExceededException;
var RelativePathException = (function (_super) {
    __extends(RelativePathException, _super);
    function RelativePathException(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, RelativePathException.prototype);
        return _this;
    }
    return RelativePathException;
}(NumException));
exports.RelativePathException = RelativePathException;
var NumLookupRedirect = (function (_super) {
    __extends(NumLookupRedirect, _super);
    function NumLookupRedirect(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumLookupRedirect.prototype);
        return _this;
    }
    return NumLookupRedirect;
}(NumException));
exports.NumLookupRedirect = NumLookupRedirect;
var NumLookupEmptyResult = (function (_super) {
    __extends(NumLookupEmptyResult, _super);
    function NumLookupEmptyResult(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumLookupEmptyResult.prototype);
        return _this;
    }
    return NumLookupEmptyResult;
}(NumException));
exports.NumLookupEmptyResult = NumLookupEmptyResult;
var NumLookupBadDoHResponse = (function (_super) {
    __extends(NumLookupBadDoHResponse, _super);
    function NumLookupBadDoHResponse(msg) {
        var _this = _super.call(this, msg) || this;
        Object.setPrototypeOf(_this, NumLookupBadDoHResponse.prototype);
        return _this;
    }
    return NumLookupBadDoHResponse;
}(NumException));
exports.NumLookupBadDoHResponse = NumLookupBadDoHResponse;
var NumProtocolErrorCode;
(function (NumProtocolErrorCode) {
    NumProtocolErrorCode["errorCreatingContext"] = "ERROR_CREATING_CONTEXT";
    NumProtocolErrorCode["compactSchemaError"] = "COMPACT_SCHEMA_ERROR";
    NumProtocolErrorCode["substitutionsFileNotFoundError"] = "SUBSTITUTIONS_FILE_NOT_FOUND";
    NumProtocolErrorCode["noUnpackerConfigFileFound"] = "UNPACKER_CONFIG_FILE_NOT_FOUND";
    NumProtocolErrorCode["expandedSchemaError"] = "EXPANDED_SCHEMA_ERROR";
    NumProtocolErrorCode["moduleConfigFileNotFound"] = "MODULE_CONFIG_FILE_NOT_FOUND";
    NumProtocolErrorCode["tooManyRedirects"] = "TOO_MANY_REDIRECTS";
    NumProtocolErrorCode["internalError"] = "INTERNAL_ERROR";
    NumProtocolErrorCode["noModlRecordFound"] = "NUM_RECORD_NOT_FOUND";
    NumProtocolErrorCode["schemaNotFound"] = "SCHEMA_NOT_FOUND";
    NumProtocolErrorCode["badDoHResponse"] = "DOH_SERVICE_ERROR";
    NumProtocolErrorCode["missingExpandedSchemaVersion"] = "EXPANDED_SCHEMA_VERSION_KEY_NOT_FOUND";
    NumProtocolErrorCode["invalidTargetExpandedSchemaForModule"] = "INVALID_TARGET_EXPANDED_SCHEMA_FOR_MODULE";
    NumProtocolErrorCode["missingTransformationsMap"] = "TRANSFORMATIONS_MAP_NOT_FOUND";
    NumProtocolErrorCode["missingLocalesList"] = "LOCALES_LIST_NOT_FOUND";
})(NumProtocolErrorCode = exports.NumProtocolErrorCode || (exports.NumProtocolErrorCode = {}));
var NumProtocolException = (function (_super) {
    __extends(NumProtocolException, _super);
    function NumProtocolException(errorCode, message) {
        var _this = _super.call(this, message) || this;
        _this.errorCode = errorCode;
        Object.setPrototypeOf(_this, NumProtocolException.prototype);
        return _this;
    }
    return NumProtocolException;
}(NumException));
exports.NumProtocolException = NumProtocolException;
//# sourceMappingURL=exceptions.js.map